import React from "react";
import { FormattedMessage } from "react-intl";

export default [
    {
        name: "truckTypeId",
        label: <FormattedMessage id="truck.truck-type" />,
        type: "list",
        helpText: <FormattedMessage id="truck-form.help-txt-truck-type" />,
        url: "/truck-types",
        filterValue: "alias",
        errorMessage: <FormattedMessage id="truck-form.err-msg-truck-type" />,
        validation: {
            required: true,
        },
        include: true,
        entityName: "truckType",
    },
    {
        name: "plateNumber",
        label: "Plate Number",
        type: "string",
        helpText: <FormattedMessage id="truck-form.help-txt-plate-number" />,
        errorMessage: <FormattedMessage id="truck-form.err-msg-plate-number" />,
        validation: {
            required: true,
        },
    },
    {
        name: "supplierId",
        label: <FormattedMessage id="truck.supplier" />,
        type: "list",
        helpText: <FormattedMessage id="truck-form.help-txt-supplier" />,
        url: "/suppliers",
        filterValue: "name",
        errorMessage: <FormattedMessage id="truck-form.err-msg-supplier" />,
        validation: {
            required: true,
        },
        include: true,
        entityName: "supplier",
    },
    {
        name: "model",
        label: <FormattedMessage id="truck.model" />,
        type: "string",
        helpText: <FormattedMessage id="truck-form.help-txt-model" />,
        errorMessage: <FormattedMessage id="truck-form.err-msg-model" />,
    },
    {
        name: "year",
        label: <FormattedMessage id="truck.year" />,
        type: "number",
        helpText: <FormattedMessage id="truck-form.help-txt-year" />,
        errorMessage: <FormattedMessage id="truck-form.err-msg-year" />,
    },
    {
        name: "truckLicense",
        label: <FormattedMessage id="truck.license" />,
        type: "file",
        initialPromptText: "Select or drag and drop truck's license photo",
        helpText: <FormattedMessage id="truck-form.help-txt-license" />,
        accept: "image/jpeg,image/gif,image/png",
        validation: {
            required: true,
        },
    },
    {
        name: "photo",
        label: <FormattedMessage id="truck.picture" />,
        type: "file",
        initialPromptText: <FormattedMessage id="truck-form.prompt-txt-picture" />,
        helpText: <FormattedMessage id="truck-form.help-txt-picture" />,
        accept: "image/jpeg,image/gif,image/png",
        validation: {
            required: true,
        },
    },
];
